import axios from 'axios';

const API_URL = process.env.REACT_APP_SERVICE_SERVER;

class ResourceService {
    // Lấy danh sách Douyin Cookies
    getDouyinCookies() {
        return axios
            .get(API_URL + '/service/v4/douyin/resource', { withCredentials: true })
            .then(response => {
                // Axios tự động parse JSON, không cần JSON.parse nữa
                return response.data;
            });
    }

    // Cập nhật Douyin Cookies
    updateDouyinCookies(cookiesData) {
        // Dựa theo code backend, API mong đợi một object với trường "data" chứa JSON string
        const requestData = { data: cookiesData };
        console.log('Request payload:', requestData);

        return axios
            .put(
                API_URL + '/service/v4/douyin/resource',
                requestData,
                { withCredentials: true }
            )
            .then(response => {
                // Axios tự động parse JSON, không cần JSON.parse nữa
                return response.data;
            })
            .catch(error => {
                console.error('API error details:', error.response?.data || error.message);
                throw error;
            });
    }

    // Xóa một cookie (cập nhật danh sách loại bỏ cookie đó)
    deleteDouyinCookie(cookieToDelete, allCookies) {
        // Lọc ra danh sách cookies không bao gồm cookie cần xóa
        const updatedCookies = allCookies.filter(cookie =>
            cookie.cookie !== cookieToDelete.cookie
        );

        // Đảm bảo vẫn còn ít nhất một cookie active
        const hasActive = updatedCookies.some(cookie => cookie.active);
        if (!hasActive && updatedCookies.length > 0) {
            updatedCookies[0].active = true;
        }

        // Gọi API cập nhật với danh sách đã lọc
        return this.updateDouyinCookies(updatedCookies);
    }

    // Thêm cookie mới
    addDouyinCookie(newCookie, allCookies) {
        // Nếu cookie mới được đánh dấu active, đảm bảo tất cả cookie khác không active
        if (newCookie.active) {
            allCookies.forEach(cookie => {
                cookie.active = false;
            });
        }

        // Thêm cookie mới vào danh sách
        const updatedCookies = [...allCookies, newCookie];

        // Gọi API cập nhật với danh sách mới
        return this.updateDouyinCookies(updatedCookies);
    }
}

export default new ResourceService(); 